module.exports = __webpack_public_path__ + "img/Ellipse7.e96d11fe.png";